/** Today's date for AI drafting prompts (Pakistan timezone). */

const DRAFT_TIMEZONE = 'Asia/Karachi';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

function draftingNow(now = new Date()): Date {
  return now;
}

function partsInKarachi(now: Date) {
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: DRAFT_TIMEZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
  const parts = formatter.formatToParts(now);
  const day = Number(parts.find((p) => p.type === 'day')?.value ?? '1');
  const month = Number(parts.find((p) => p.type === 'month')?.value ?? '1');
  const year = Number(parts.find((p) => p.type === 'year')?.value ?? '1970');
  return { day, month, year };
}

function ordinal(day: number): string {
  if (day >= 11 && day <= 13) return `${day}th`;
  const suffix = { 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] ?? 'th';
  return `${day}${suffix}`;
}

export function getDraftingDateContext(now = draftingNow()): string {
  const { day, month, year } = partsInKarachi(now);
  const monthName = MONTHS[month - 1] ?? 'January';
  const lexgatDate = `____.${String(month).padStart(2, '0')}.${year}`;
  const iso = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

  return `Today's Date / Year (Pakistan — use on NEW drafting):
- Calendar date: ${ordinal(day)} day of ${monthName}, ${year}
- Today's year for court captions: ${year}
- Numeric (LexGAT template style): ${lexgatDate}
- ISO: ${iso}

Court caption lines (centered header) MUST include the year of institution — do NOT omit "of ${year}":
- CM No. _______ of ${year}
- In (on its own line)
- Civil Suit No. _______ of ${year}
Use ${year} instead of 2024 unless case facts give a different suit year.

For execution, verification, filing, and signature dates, use Today's Date above.
When quoting an existing court order, notice, or judgment date from case facts, keep that historical date exactly.`;
}
